import { NETWORKS } from "../constants";

export const getNetworkByChainId = chainId => {
  const networks = getNetworks();

  return Object.keys(networks).find(network => networks[network]?.chainId === chainId);
};

export const getNetworkPriceByChainId = chainId => {
  const network = getNetworkByChainId(chainId);
  const networks = getNetworks();

  if (!networks[network]) return;

  return networks[network].price;
};

export const getNetworks = () => {
  try {
    let customNetworks = JSON.parse(localStorage.getItem("custom-networks"));
    customNetworks = customNetworks || {};

    return {
      ...NETWORKS,
      ...customNetworks,
    };
  } catch (e) {
    return NETWORKS;
  }
};
